import { createSlice } from '@reduxjs/toolkit';

const initialProductState = {
  product: {},
  merchantCredential: {},
  terminalList: { list: [], cursor_id: '' },
  productList: { list: [], cursor_id: '' },
  transactionList: { list: [], cursor_id: '' },
  terminalListStatusFilter: '',
};

const productSlice = createSlice({
  name: 'productData',
  initialState: initialProductState,
  reducers: {
    updateProductData(state, { payload }) {
      state.product = payload;
    },
    updateMerchantCredential(state, { payload }) {
      state.merchantCredential = payload;
    },
    updateTerminalList(state, { payload }) {
      state.terminalList = payload;
    },
    updateTerminalListStatus(state, { payload }) {
      state.terminalListStatusFilter = payload;
    },
    updateProductList(state, { payload }) {
      state.productList = payload;
    },
    clearProduct(state) {
      state.product = {};
    },
    clearProductList(state) {
      state.productList = { list: [], cursor_id: '' };
    },
    clearTerminalList(state) {
      state.terminalList = { list: [], cursor_id: '' };
    },
    clearAllProduct: () => initialProductState,
    updateTransactionList(state, { payload }) {
      state.transactionList = payload;
    },
    clearTransactionList(state) {
      state.transactionList = { list: [], cursor_id: '' };
    },
  },
});

export const {
  updateProductData,
  updateMerchantCredential,
  updateProductList,
  updateTerminalList,
  updateTerminalListStatus,
  clearProduct,
  clearProductList,
  clearTerminalList,
  clearAllProduct,
  updateTransactionList,
  clearTransactionList,
} = productSlice.actions;
export default productSlice.reducer;
